import { ProgressionCoursesTypes } from './types';

export const getLastClass = (course_id: number) => ({
  types: [
    ProgressionCoursesTypes.GET_PROGRESSION_REQUEST,
    ProgressionCoursesTypes.GET_PROGRESSION_SUCCESS,
    ProgressionCoursesTypes.GET_PROGRESSION_FAILURE,
  ],
  promise: (client: any) => client.get(`/courses/get_last_class`, { params: { course_id } }),
});

export const PreviousClass = (ordem_id: number, course_id: number) => ({
  types: [
    ProgressionCoursesTypes.PREVIOUS_CLASS_REQUEST,
    ProgressionCoursesTypes.PREVIOUS_CLASS_SUCCESS,
    ProgressionCoursesTypes.PREVIOUS_CLASS_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/courses/previous_class`, { params: { ordem_id, course_id } }),
});

export const current_class_status = (id: number) => ({
  types: [
    ProgressionCoursesTypes.CURRENT_CLASS_STATUS_REQUEST,
    ProgressionCoursesTypes.CURRENT_CLASS_STATUS_SUCCESS,
    ProgressionCoursesTypes.CURRENT_CLASS_STATUS_FAILURE,
  ],
  promise: (client: any) => client.get(`/courses/current_class_status`, { params: { id } }),
});

export const count_topics = () => ({
  types: [
    ProgressionCoursesTypes.TOTAL_COMPLETED_REQUEST,
    ProgressionCoursesTypes.TOTAL_COMPLETED_SUCCESS,
    ProgressionCoursesTypes.TOTAL_COMPLETED_FAILURE,
  ],
  promise: (client: any) => client.get(`/courses/count_topics`),
});
